module.exports = __webpack_public_path__ + "img/max-koli-plane.a7c0d10c.svg";